/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useMedia } from "react-use";
import cn from "clsx";
import { HeaderMenu } from "./header-menu";
import { AccountButtons } from "./account-buttons";
import { ReportProblemLink } from "./report-problem-link";
import { ContactUsLink } from "./contact-us-link";

const HeaderNavBar = () => {

    const isDesktop = useMedia("screen and (min-width: 835px)");

    const containerClass = cn("header-nav-bar", { "mobile": !isDesktop });

    return (
        <div className={containerClass}>
            <div className='services-header'>
                {isDesktop &&
                <>
                    <HeaderMenu />
                    <div className='header-nav-bar-links'>
                        <ReportProblemLink />
                        <ContactUsLink />
                    </div>
                </>
                }
                {!isDesktop && <AccountButtons />}
            </div>
        </div>
    );
};

export { HeaderNavBar };
